import { RouteComponentProps, withRouter } from "react-router";
import { AuthenticatedTemplate } from "@azure/msal-react";
import {
  IonButtons,
  IonHeader,
  IonToolbar,
  IonButton,
  IonTitle,
  IonMenuButton,
  IonRouterLink,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  IonAvatar,
  IonText,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  IonItem,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  IonLabel,
  IonIcon,
} from "@ionic/react";
import {
  chevronForwardOutline,
  logInOutline,
  logOutOutline,
} from "ionicons/icons";
import ContactProfileImage from "./ContactProfileImage";
import NavBarItem from "./NavBarItem";
import NavToolBar from "./NavToolBar";

import { useUserDetails } from "../../hooks/useUserDetails";
import { useQueryClient } from "@tanstack/react-query";
import { useMyDetails } from "../../hooks/useMyDetails";

import "./AppHeader.css";

interface ContainerProps extends RouteComponentProps<any> {
  title?: string;
  tools?: boolean;
}

// eslint-disable-next-line react-refresh/only-export-components
const AppHeader: React.FC<ContainerProps> = ({ title, tools }) => {
  const queryClient = useQueryClient();
  const { instance, accounts, logout } = useUserDetails();
  const { myDetails } = useMyDetails();

  const handleLogin = () => {
    // instance.loginPopup();
    instance.loginRedirect();
    queryClient.clear();
  };
  const handleLogout = () => {
    // Clean up and logout
    queryClient.clear();
    logout();
  };

  return (
    <IonHeader className="app-header">
      <IonToolbar>
        <AuthenticatedTemplate>
          <IonButtons slot="start">
            <IonMenuButton
              menu="start"
              autoHide={false}
              title={"My Menu"}
            ></IonMenuButton>
            <IonButton slot="start" title={"Covers"}>
              <IonRouterLink routerLink="/home">
                <div className="plc-horizontal-logo"></div>
              </IonRouterLink>
            </IonButton>
            {tools && <NavToolBar />}
          </IonButtons>
        </AuthenticatedTemplate>
        <IonTitle className="app-header-title">
          {title ? title : "Covers Manager"}
        </IonTitle>
        <IonButtons slot="end">
          {myDetails && myDetails?.GivenName && (
            <div className="user-details">
              <IonButton
                // routerLink="/settings"
                size="default"
                title={"My Settings"}
              >
                {/* <IonAvatar
                  className="nav-user-photo"
                  key={myDetails?._id + "-p"}
                  title={`${userData.displayName}`}
                >
                  <img src={userPhoto?.url ?? ""} />
                </IonAvatar> */}
                <ContactProfileImage
                  key={myDetails?._id + "-s"}
                  cssClass="nav-user-photo"
                  profile={{ contactId: myDetails?._id }}
                  onSelect={() => {
                    console.log("disabled for this card.");
                  }}
                />
                <IonText>{`Hi ${myDetails.GivenName}`}</IonText>
                <IonIcon icon={chevronForwardOutline} />
              </IonButton>
            </div>
          )}
          {accounts.length > 0 && (
            <NavBarItem
              onClick={handleLogout}
              iconOn={logOutOutline}
              iconOff={logOutOutline}
              title={"Sign Out"}
            />
          )}
          {/* eslint-disable-next-line no-constant-binary-expression */}
          {false && accounts.length <= 0 && (
            <NavBarItem
              onClick={handleLogin}
              iconOn={logInOutline}
              iconOff={logInOutline}
              title={"Sign In"}
            />
          )}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default withRouter(AppHeader);
